import React, { useMemo } from 'react';
import { getLabelTextDefault } from './helpers';
import { LabelSelected, TagSelected } from './styled';
export var TagPlaceholder = function (_a) {
    var onClose = _a.onClose, size = _a.size, count = _a.count, _b = _a.getLabelText, getLabelText = _b === void 0 ? getLabelTextDefault : _b;
    var labelText = useMemo(function () { return getLabelText(count, size); }, [getLabelText, size, count]);
    return (React.createElement(TagSelected, { closable: true, onClose: onClose },
        React.createElement(LabelSelected, null, labelText)));
};
//# sourceMappingURL=TagPlaceholder.js.map